<template><article class="team-card"><img :src="member.image" :alt="member.name"><div><span>{{member.position}}</span><h3>{{member.name}}</h3><p>{{member.bio}}</p></div></article></template>
<script>export default {name:'TeamMember',props:{member:{type:Object,required:true}}}</script>
